import React from "react";
import { Link } from "react-router-dom";
import { Lock, Truck, CreditCard, ShieldCheck, ExternalLink } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0B] border-t border-white/10 pt-16 pb-12 text-[#A1A1AA] text-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Trust Badges */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 pb-12 border-b border-white/10">
          <div className="flex items-center gap-4 p-4 rounded-2xl bg-[#121214] border border-white/10">
            <div className="w-10 h-10 rounded-xl bg-[#18181B] border border-white/10 flex items-center justify-center text-[#FF8C69]">
              <Lock className="w-5 h-5" />
            </div>
            <div>
              <p className="font-bold text-xs text-white">Embalagem Discreta</p>
              <p className="text-[11px] text-[#A1A1AA]">Sem referências ou logos externos</p>
            </div>
          </div>

          <div className="flex items-center gap-4 p-4 rounded-2xl bg-[#121214] border border-white/10">
            <div className="w-10 h-10 rounded-xl bg-[#18181B] border border-white/10 flex items-center justify-center text-[#FF8C69]">
              <Truck className="w-5 h-5" />
            </div>
            <div>
              <p className="font-bold text-xs text-white">Envio Correios</p>
              <p className="text-[11px] text-[#A1A1AA]">SEDEX e PAC com rastreamento</p>
            </div>
          </div>

          <div className="flex items-center gap-4 p-4 rounded-2xl bg-[#121214] border border-white/10">
            <div className="w-10 h-10 rounded-xl bg-[#18181B] border border-white/10 flex items-center justify-center text-[#FF8C69]">
              <CreditCard className="w-5 h-5" />
            </div>
            <div>
              <p className="font-bold text-xs text-white">InfinitePay Seguro</p>
              <p className="text-[11px] text-[#A1A1AA]">Pix instantâneo e Cartão até 12x</p>
            </div>
          </div>

          <div className="flex items-center gap-4 p-4 rounded-2xl bg-[#121214] border border-white/10">
            <div className="w-10 h-10 rounded-xl bg-[#18181B] border border-white/10 flex items-center justify-center text-[#FF8C69]">
              <ShieldCheck className="w-5 h-5" />
            </div>
            <div>
              <p className="font-bold text-xs text-white">Login Seguro SSO</p>
              <p className="text-[11px] text-[#A1A1AA]">Integração oficial joycesxy.com</p>
            </div>
          </div>
        </div>

        {/* Links */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 py-12">
          <div className="space-y-4">
            <div className="flex items-center gap-2.5">
              <img
                src="/logo.png"
                alt="Joyce SXY"
                className="h-8 w-auto object-contain"
              />
              <span className="font-heading text-xl font-bold text-[#FF8C69]">
                Joyce SXY
              </span>
            </div>
            <p className="text-xs leading-relaxed text-[#A1A1AA]">
              Loja virtual oficial do domínio joycesxyloja.com, com navegação integrada ao ecossistema joycesxy.com.
            </p>
            <a
              href="https://joycesxy.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-xs text-[#FF8C69] hover:text-white transition-colors font-bold"
            >
              <span>Acessar joycesxy.com</span>
              <ExternalLink className="w-3.5 h-3.5" />
            </a>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4">Departamentos</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/?category=cat_lingerie" className="hover:text-[#FF8C69] transition-colors">Moda Íntima</Link></li>
              <li><Link to="/?category=cat_perfumes" className="hover:text-[#FF8C69] transition-colors">Perfumaria</Link></li>
              <li><Link to="/?category=cat_colecoes" className="hover:text-[#FF8C69] transition-colors">Coleções Especiais</Link></li>
              <li><Link to="/?category=cat_acessorios" className="hover:text-[#FF8C69] transition-colors">Acessórios</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4">Atendimento</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/pedidos" className="hover:text-[#FF8C69] transition-colors">Rastrear Pedido</Link></li>
              <li><span className="text-[#A1A1AA]">Email: suporte@joycesxyloja.com</span></li>
              <li><span className="text-[#A1A1AA]">Horário: Seg - Sex das 09h às 18h</span></li>
              <li><span className="text-[#A1A1AA]">Origem: São Paulo/SP</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-white mb-4">Segurança & Privacidade</h4>
            <div className="space-y-2 text-xs text-[#A1A1AA]">
              <p>Conexão segura HTTPS e proteção de dados LGPD.</p>
              <p>Pagamentos processados diretamente pela InfinitePay.</p>
              <p className="text-[#FF8C69] font-bold pt-1">joycesxyloja.com</p>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#A1A1AA]/70">
          <p>© {new Date().getFullYear()} Joyce SXY — Todos os direitos reservados.</p>
          <p>Ambiente seguro e protegido</p>
        </div>

      </div>
    </footer>
  );
}
